module.exports = "/assets/data/4b098a28cf4c2d8cde36e990b11079ee-LA7.data.json";